export function FieldError({ message }) {
  if (!message) return null;
  return <div className="text-xs text-red-700 mt-1">{message}</div>;
}
